<template>
  <!--  BACKGROUND TABS END  -->
  <div
    class="w-full lg:h-[783px] mx-auto py-[60px]"
    v-bind:class="{
      '': openTab !== 1,
      'background-tabs-1': openTab === 1,
      '': openTab !== 2,
      'background-tabs-2': openTab === 2,
      '': openTab !== 3,
      'background-tabs-3': openTab === 3
    }"
  >
    <div class="lg:w-[1140px] mx-auto">
      <h2
        class="px-auto top-full px-[25px] text-sm lg:text-xs font-bold text-[#FFC800]"
      >
        MONETIZE
      </h2>
    </div>

    <div class="mx-auto lg:w-[1140px]">
      <div class="lg:flex lg:h-[100px] pt-[25px] justify-between">
        <ul
          class="list-none py-auto w-full lg:flex justify-between gap-2 pl-[30px] pr-[100px]"
        >
          <li
            class="lg:text-center cursor-pointer"
            v-on:click="toggleTabs(1)"
            v-bind:class="{
              'text-[#ffffff80] hover:text-[#ffffffc0] hover:ease-in-out text-[25px] lg:[35px]':
                openTab !== 1,
              'text-white text-[25px] lg:text-[50px] lg:leading-10':
                openTab === 1
            }"
          >
            <a class="mt-3 font-bold block cursor-pointer"> Upsells </a>
          </li>
          <div
            class="bg-[#FFC800] rounded-full h-[6px] w-[50px] mt-[20px] lg:hidden"
            v-bind:class="{ hidden: openTab !== 1, block: openTab === 1 }"
          ></div>

          <li
            class="lg:text-center cursor-pointer lg:border-l-[5px] lg:border-[#ffffff80] lg:pl-[30px] mt-[30px] lg:mt-0"
            v-on:click="toggleTabs(2)"
            v-bind:class="{
              'text-[#ffffff80] hover:text-[#ffffffc0] hover:ease-in-out text-[25px] lg:[35px]':
                openTab !== 2,
              'text-white text-[25px] lg:text-[50px] lg:leading-10':
                openTab === 2
            }"
          >
            <a class="mt-3 font-bold block cursor-pointer"> Checkout Carts </a>
          </li>
          <div
            class="bg-[#FFC800] rounded-full h-[6px] w-[50px] mt-[20px] lg:hidden"
            v-bind:class="{ hidden: openTab !== 2, block: openTab === 2 }"
          ></div>

          <li
            class="lg:text-center cursor-pointer lg:border-l-[5px] lg:border-[#ffffff80] lg:pl-[30px] mt-[30px] lg:mt-0"
            v-on:click="toggleTabs(3)"
            v-bind:class="{
              'text-[#ffffff80] hover:text-[#ffffffc0] hover:ease-in-out text-[25px] lg:[35px]':
                openTab !== 3,
              'text-white text-[25px] lg:text-[50px] lg:leading-10':
                openTab === 3
            }"
          >
            <a class="mt-3 font-bold block cursor-pointer"> Beyond Courses </a>
          </li>
          <div
            class="bg-[#FFC800] rounded-full h-[6px] w-[50px] mt-[20px] lg:hidden"
            v-bind:class="{ hidden: openTab !== 3, ' block': openTab === 3 }"
          ></div>
        </ul>
      </div>

      <div
        class="bg-[#FFC800] rounded-full h-[6px] w-[100px] mt-[20px] hidden lg:block"
        v-bind:class="{
          '': openTab !== 1,
          ' ml-[30px]': openTab === 1,
          '': openTab !== 2,
          'ml-[260px]': openTab === 2,
          '': openTab !== 3,
          ' ml-[625px]': openTab === 3
        }"
      ></div>
    </div>

    <!-- CONTENT CARD MOBILE -->

    <div
      class="mt-[30px] gap-10 lg:hidden"
      v-bind:class="{
        hidden: openTab !== 1,
        'block bg-no-repeat ': openTab === 1
      }"
    >
      <img
        class="px-[20px]"
        :src="
          $filters.media_path(
            '/images/upsell-high-ticket-digital-products-in-your-members-area.png'
          )
        "
        alt="Platforma video channel video scheduler."
      />

      <div class="my-auto">
        <p class="mt-[25px] px-[20px] text-lg text-white">
          100X CLV (Customer Lifetime Value) by including unlimited upsells of
          different products. The Ultimate Funnel pressure cooker is here and
          can be used any way imaginable.
        </p>
      </div>
    </div>

    <div
      class="gap-10 lg:hidden"
      v-bind:class="{
        hidden: openTab !== 2,
        'block py-5 bg-no-repeat ': openTab === 2
      }"
    >
      <img
        class="px-[20px] lg:w-[601px] lg:h-[374px] my-auto"
        :src="
          $filters.media_path(
            '/images/upsell-high-ticket-digital-products-in-your-members-area.png'
          )
        "
        alt="Platforma video channel video scheduler."
      />

      <div class="my-auto">
        <p class="mt-[25px] px-[20px] text-lg text-white">
          Quickly and easily process payments for member access to the private
          platform.
        </p>
      </div>
    </div>

    <div
      class="gap-10 lg:hidden"
      v-bind:class="{
        hidden: openTab !== 3,
        'block py-5 bg-no-repeat ': openTab === 3
      }"
    >
      <img
        class="px-[20px] lg:w-[601px] lg:h-[374px] my-auto"
        :src="
          $filters.media_path(
            '/images/course-builder-with-advanced-features-more-than-videos.png'
          )
        "
        alt="Platforma video channel video scheduler."
      />

      <div class="my-auto">
        <p class="mt-[25px] px-[20px] text-lg text-white">
          Embed physical product storefronts, group newsfeeds, video channels,
          live streaming webinars, 1-on-1 video calls and chat, plus more for
          members to consume beyond courses.
        </p>
      </div>
    </div>

    <!-- <div class="flex flex-wrap mt-10">
    
              
    
          </div> -->

    <!-- CONTENT TAB SECTION DESKTOP -->

    <div
      class="hidden relative mt-[40px] lg:flex min-w-0 break-words lg:w-[1140px] mb-6 pt-3 lg:h-[554px] mx-auto px-[30px]"
    >
      <div class="lg:flex">
        <div class="w-[180px]">
          <p
            class="mt-[25px] text-lg text-white leading-8"
            v-bind:class="{ hidden: openTab !== 1, 'block ': openTab === 1 }"
          >
            100X CLV (Customer Lifetime Value) by including unlimited upsells of
            different products. The Ultimate Funnel pressure cooker is here and
            can be used any way imaginable.
          </p>

          <p
            class="mt-[25px] text-lg text-white leading-8"
            v-bind:class="{ hidden: openTab !== 2, 'block ': openTab === 2 }"
          >
            Quickly and easily process payments for member access to the private
            platform.
          </p>

          <p
            class="mt-[25px] text-lg text-white leading-8"
            v-bind:class="{ hidden: openTab !== 3, 'block ': openTab === 3 }"
          >
            Embed physical product storefronts, group newsfeeds, video channels,
            live streaming webinars, 1-on-1 video calls and chat, plus more for
            members to consume beyond courses.
          </p>
        </div>

        <div class="tab-content tab-space lg:flex">
          <div
            class="flex gap-10"
            v-bind:class="{
              hidden: openTab !== 1,
              'block p-[30px] py-5 bg-no-repeat ': openTab === 1
            }"
          >
            <img
              class="lg:w-[691px] lg:h-[459px]"
              :src="
                $filters.media_path(
                  '/images/upsell-high-ticket-digital-products-in-your-members-area.png'
                )
              "
              alt="Platforma video channel video scheduler."
            />
          </div>

          <div
            class="flex gap-10"
            v-bind:class="{
              hidden: openTab !== 2,
              'block p-[30px] py-5 bg-no-repeat ': openTab === 2
            }"
          >
            <img
              class=""
              :src="
                $filters.media_path(
                  '/images/platforma-course-members-checkout-pages.png'
                )
              "
              alt="Checkout Page to sell your course."
            />
          </div>
          <div
            class="flex gap-10"
            v-bind:class="{
              hidden: openTab !== 3,
              'block  p-[30px] py-5 bg-no-repeat ': openTab === 3
            }"
          >
            <img
              class="lg:w-[691px] lg:h-[459px]"
              :src="
                $filters.media_path(
                  '/images/course-builder-with-advanced-features-more-than-videos.png'
                )
              "
              alt="Platforma video channel video scheduler."
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  BACKGROUND TABS END  -->
</template>

<!-- SCRIPTS -->

<script>
export default {
  name: 'pink-tabs',
  data() {
    return {
      openTab: 1
    };
  },

  methods: {
    toggleTabs: function (tabNumber) {
      this.openTab = tabNumber;
    }
  }
};
</script>

<!-- STYLES -->

<style scoped>
.background-tabs-1 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #2d8cff, #2d8bffaf);
  background-repeat: repeat;
  background-position: center;
}
.background-tabs-2 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #27ae60, #27ae5fbb);
  background-repeat: repeat;
  background-position: center;
}
.background-tabs-3 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #49ccf9, #49cdf9b2);
  background-repeat: repeat;
  background-position: center;
}
</style>
